<template>
  <div class="flex flex-wrap col-12">
    <div
      class="flex pointer white-bg col-12 card-top"
      @click="handleClick(product)"
    >
      <div class="flex flex-wrap col-12">
        <div class="flex col-1 lg-col-1 md-col-1 sm-col-2 items-center">
          <div class="flex items-center full-height">
            <span
              :class="[
                'custom-radio flex',
                { 'selected-item': isSelected },
              ]"
            ></span>
          </div>
        </div>
        <div class="flex flex-wrap items-center col-10 lg-col-10 md-col-10 sm-col-9">
          <span class="flex col-12 bold h4 items-center">
            {{ product.name }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    isSelected () {
      return this.$store.state.product?.uuid === this.product.uuid;
    }
  },
  methods: {
    handleClick (product) {
      if (!this.isSelected) {
        this.$store.commit('setProduct', product);
        this.$emit('product-selected', product.uuid);
      }
    }
  }
};
</script>
